import { Router } from '@angular/router';
import { ConnectorAuthService } from './connector-auth.service';
import * as i0 from "@angular/core";
import * as i1 from "./connector-auth.service";
import * as i2 from "@angular/router";
var IdasAuthGuard = /** @class */ (function () {
    function IdasAuthGuard(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    IdasAuthGuard.prototype.canActivate = function () {
        if (this.authService.isLoggedIn) {
            return this.authService.isLoggedIn;
        }
        else {
            this.handleNotLoggedIn();
            return this.authService.isLoggedIn;
        }
    };
    // canActivate(): boolean {
    //     return true;
    // }
    IdasAuthGuard.prototype.handleNotLoggedIn = function () {
        this.router.navigate(['/']);
    };
    IdasAuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function IdasAuthGuard_Factory() { return new IdasAuthGuard(i0.inject(i1.ConnectorAuthService), i0.inject(i2.Router)); }, token: IdasAuthGuard, providedIn: "root" });
    return IdasAuthGuard;
}());
export { IdasAuthGuard };
